import { Form, Input } from 'antd';
import axios from 'axios';
import { navigate } from 'gatsby';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import SelectWithLabel from 'components/Form/SelectWithLabel';
import TextFieldWithLabel from 'components/Form/TextFieldWithLabel';
import Button from 'components/Button';
import { init, saveForm } from 'services/marketoService';
import { industryList, otherIndustryList } from 'components/Form/utils/generalFormData';
import { GraderFormContainer, FormStep } from '../styles';
import { FormContainer } from '../../styles';

const GraderForm = ({
  width,
  height,
  background,
  titleColor,
  title,
  buttonTitle,
  footer,
  shadow,
  marketoId,
  marketoURL,
  marketoFormId,
  setTitle,
  setDescription,
  ...otherProps
}) => {
  const dropdownIndustry = industryList.slice(1);
  const dropdownOtherIndustry = otherIndustryList.slice(1);
  const [isOtherIndustryShow, setOtherIndustryShow] = useState(false);
  const [isUpdate, setUpdate] = useState(false);
  const [count, setCount] = useState(0);
  const [formSubmissions, setFormSubmissions] = useState(true);
  const [values, setValues] = useState({
    email: '',
    firstName: '',
    lastName: '',
    company: '',
    technicians: '',
    industry: '',
    otherIndustry: '',
    postalCode: '',
    mobilePhone: '',
    averageTicketSize: '',
    completedJobs: '',
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    utm_promo: null,
    gclid: '',
    creative: '',
    keyword: '',
    matchtype: '',
  });
  const [formValid, setFormValid] = useState({
    email: 0,
    firstName: 0,
    lastName: 0,
    mobilePhone: 0,
    company: 0,
    technicians: 0,
    industry: 0,
    otherIndustry: 0,
    postalCode: 0,
    averageTicketSize: 0,
    completedJobs: 0,
  });
  const [formErrors, setFormErrors] = useState({
    email: '',
    firstName: '',
    lastName: '',
    mobilePhone: '',
    company: '',
    technicians: '',
    industry: '',
    otherIndustry: '',
    postalCode: '',
    averageTicketSize: '',
    completedJobs: '',
  });

  const nameType = {
    email: '* Email address',
    firstName: '* First Name',
    lastName: '* Last Name',
    mobilePhone: '* Phone Number',
    company: '* Company',
    technicians: '* How many technicians do you have?',
    industry: '* Industry',
    otherIndustry: '* Other industry',
    postalCode: '* Postal code',
    averageTicketSize: '* Average ticket size ($)',
    completedJobs: '* How many jobs have you completed in the last 30 days?',
  };

  useEffect(() => {
    init(marketoFormId);

    let url = window.location.search;
    let params = queryString.parse(url);
    const tempValues = { ...values };
    Object.keys(tempValues).map(key => {
      if (params[key]) {
        tempValues[key] = params[key];
        Cookies.set(key, params[key]);
      } else {
        const p = Cookies.get(key);
        if (p && p !== undefined) {
          tempValues[key] = p;
        }
      }
    });
    setValues(tempValues);
  }, []);

  useEffect(() => {}, [count]);

  const onHandleBlur = (id, newValue) => {
    checkFieldValidate(id, newValue);
  };

  const onHandleChange = (id, newValue) => {
    let tmpValues = Object.assign({}, values);
    tmpValues[id] = newValue;
    setValues(tmpValues);

    if (id === 'industry' || id === 'otherIndustry') {
      checkFieldValidate(id, newValue);
    }

    if (id === 'industry') {
      if (newValue === 'Other') {
        setFormValid[otherIndustry] = 0;
        setOtherIndustryShow(true);
      } else if (newValue != 'Other') {
        setOtherIndustryShow(false);
      }
    }
  };

  async function checkFieldValidate(id, value) {
    let fieldValidation = formValid;
    let fieldValidationErrors = formErrors;

    fieldValidation[id] = 1;
    if (id === 'otherIndustry') {
      if (isOtherIndustryShow) {
        fieldValidation[id] = value != '' ? 1 : -1;
        fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : nameType[id];
      }
    } else if (id === 'mobilePhone') {
      fieldValidation[id] = value.length === 14 ? 1 : -1;
      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : nameType[id] + ' is required';
    } else if (id === 'email') {
      fieldValidation[id] = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : -1;
      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : nameType[id] + ' is required';
    } else if (id === 'technicians' || id === 'averageTicketSize' || id === 'completedJobs') {
      fieldValidation[id] = value && value.length >= 1 ? 1 : -1;
      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : nameType[id] + ' is required';
    } else {
      fieldValidation[id] = value && value != '' ? 1 : -1;
      fieldValidationErrors[id] = fieldValidation[id] === 1 ? '' : nameType[id] + ' is not valid';
    }

    setFormValid(fieldValidation);
    setFormErrors(fieldValidationErrors);
    setUpdate(!isUpdate);

    return fieldValidation[id];
  }

  async function checkStepValidate() {
    let stepValid = 0;
    let stepFields = [];

    stepFields = [
      'firstName',
      'lastName',
      'mobilePhone',
      'company',
      'email',
      'technicians',
      'industry',
      'otherIndustry',
      'postalCode',
      'averageTicketSize',
      'completedJobs',
    ];

    for (var c in stepFields) {
      const element = stepFields[c];
      stepValid += await checkFieldValidate(element, values[element]);
    }
    const formValidCount = stepValid === stepFields.length;
    return formValidCount;
  }

  async function onSubmitStepOne() {
    if (await checkStepValidate()) {
      fetchMarketoData(values, 1);
      dataLayer.push({
        event: 'calculator',
        calculator_type: 'Business Grader Form',
        first_name: values.firstName,
        last_name: values.lastName,
        phone_number: values.mobilePhone,
        email: values.email,
        no_of_technicians: values.technicians,
        industry: values.industry,
        other_industry: values.industry === 'Other' ? values.otherIndustry : '',
        average_ticket_size: values.averageTicketSize,
        completed_jobs: values.completedJobs,
        utm_source: values.utm_source,
        utm_medium: values.utm_medium,
        utm_campaign: values.utm_campaign,
        utm_content: values.utm_content,
        utm_term: values.utm_term,
        utm_promo: values.utm_promo,
        gclid: values.gclid,
        creative: values.creative,
        keyword: values.keyword,
        matchtype: values.matchtype,
      });

      Cookies.set('firstName', values.firstName);
      Cookies.set('lastName', values.lastName);
      Cookies.set('mobilePhone', values.mobilePhone);
      Cookies.set('email', values.email);
      Cookies.set('company', values.company);
    }
    setFormSubmissions(!formSubmissions);
  }

  const fetchMarketoData = async (data, step) => {
    let response;

    try {
      response = await saveForm({
        ...data,
        marketoFormId,
        step: step,
      });
    } catch (e) {}

    navigate('/tools/service-business-grader/2', { state: { values } });
  };

  return (
    <FormContainer {...otherProps}>
      <div className="section-tool-page-form--wrapper">
        <div className="section-tool-page-form--container">
          <GraderFormContainer
            width={width}
            height={height}
            background={background}
            titleColor={titleColor}
            shadow={shadow}
            {...otherProps}
          >
            <p className="signup-form--description">* All fields required</p>
            <Form className="signup-form--form" data-position="business grader">
              <FormStep>
                <Form.Item>
                  <TextFieldWithLabel
                    id="firstName"
                    label="First Name"
                    type="text"
                    nameType={nameType['firstName']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="lastName"
                    label="Last Name"
                    type="text"
                    nameType={nameType['lastName']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="mobilePhone"
                    label="Phone Number"
                    type="number"
                    nameType={nameType['mobilePhone']}
                    format="(###) ###-####"
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="company"
                    label="Company name"
                    type="text"
                    nameType={nameType['company']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="email"
                    label="Email address"
                    type="text"
                    nameType={nameType['email']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="technicians"
                    label="How many technicians do you have?"
                    type="number"
                    nameType={nameType['technicians']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <SelectWithLabel
                    id="industry"
                    nameType={nameType['industry']}
                    formValid={formValid}
                    formErrors={formErrors}
                    placeholder="Select industry..."
                    options={dropdownIndustry}
                    handleChange={onHandleChange}
                  />
                </Form.Item>
                <Form.Item className={isOtherIndustryShow ? '' : 'hide-form-item'}>
                  <SelectWithLabel
                    id="otherIndustry"
                    nameType={nameType['otherIndustry']}
                    formValid={formValid}
                    formErrors={formErrors}
                    placeholder="Select other industry..."
                    options={dropdownOtherIndustry}
                    handleChange={onHandleChange}
                  />
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="postalCode"
                    type="number"
                    nameType={nameType['postalCode']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="averageTicketSize"
                    type="number"
                    nameType={nameType['averageTicketSize']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                    placeholderText="$"
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item>
                  <TextFieldWithLabel
                    id="completedJobs"
                    label="How many jobs have you completed in the last 30 days?"
                    type="number"
                    nameType={nameType['completedJobs']}
                    values={values}
                    formValid={formValid}
                    formErrors={formErrors}
                    handleBlur={onHandleBlur}
                    handleChange={onHandleChange}
                    isRequired={true}
                  >
                    <Input />
                  </TextFieldWithLabel>
                </Form.Item>
                <Form.Item data-position="Form - Next CTA">
                  <Button
                    className="signup-form--submit-button"
                    type="primary"
                    width="100%"
                    shadow={false}
                    onClick={onSubmitStepOne}
                  >
                    {buttonTitle}
                  </Button>
                </Form.Item>
                <div className="form-progress">
                  <div className="form-step active"></div>
                  <div className="form-step"></div>
                  <div className="form-step"></div>
                </div>
              </FormStep>
            </Form>
          </GraderFormContainer>
        </div>
      </div>
    </FormContainer>
  );
};

GraderForm.defaultProps = {
  background: '#ffffff',
  buttonTitle: 'Next',
  footer: '',
  shadow: true,
};

export const BCGraderForm = GraderForm;
